import { render, staticRenderFns } from "./workHistory[id].vue?vue&type=template&id=d1fdc200&"
import script from "./workHistory[id].vue?vue&type=script&lang=js&"
export * from "./workHistory[id].vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports